export default __webpack_public_path__ + "static/media/casa_zumzi.228fbb5e.png";